export const SNACK_BAR_MESSAGE_TYPES = {
  SUCCESS: 'green-success-snackbar',
  WARNING: 'orange-warning-snackbar',
  ERROR: 'red-error-snackbar',
  DEFAULT: 'default-snackbar',
} as const satisfies Record<string, string>;

export type SnackbarMessageTypes =
  (typeof SNACK_BAR_MESSAGE_TYPES)[keyof typeof SNACK_BAR_MESSAGE_TYPES];
